import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import Icon from './icon';
import AiIframe from 'js/searches/ai_iframe';
import ReactDOM from 'react-dom/client';
import apiRequest from 'js/common/api_request';

export const AI_TAB_TITLE = 'AI Teacher Tools';

const SearchTabIcons = {
  Resources: {
    base: {
      icon: 'fa-file-lines'
    },
    detail: {
      icon: 'fa-globe text-[0.9em]',
      positioning: 'text-right w-11/12 top-2.5'
    }
  },
  Media: {
    base: {
      icon: 'fa-circle-play',
      activeClasses: 'fa-regular'
    },
    detail: {
      icon: 'fa-volume',
      positioning: 'text-right w-11/12 top-2 left-1'
    }
  },
  Collections: {
    base: {
      icon: 'fa-folders'
    },
    detail: {
      icon: 'fa-list text-[0.8em] left-1',
      activeClasses: 'text-white -mt-px'
    }
  },
  [AI_TAB_TITLE]: {
    base: {
      icon: 'fa-sparkles'
    },
    detail: {
      icon: null
    }
  }
};

const SearchTab = ({ id, isActive, onClick, title, subtitle, unsupportedParams }) => {
  const [aiIframeLoaded, setAiIframeLoaded] = useState(false);
  const isAiTab = (title == AI_TAB_TITLE);

  useEffect(() => {
    if (isAiTab && isActive && !aiIframeLoaded) {
      if (LP.config.ai_enabled) {
        const aiIframeContainer = document.getElementById('iframe-area');
        const searchParams = new URLSearchParams(window.location.search);
        const ai_tool = searchParams.get("ai_tool");
        const keywords = searchParams.get("keywords");
        const grade_ids = searchParams.getAll("grade_ids[]");
        apiRequest.get(LP.config.generate_ai_iframe_url, {
          params: {
            ai_tool,
            keywords,
            grade_ids
          }
        })
          .then((response) => {
            ReactDOM.createRoot(aiIframeContainer).render(
              React.createElement(AiIframe, { url: response.data.url })
            );
            setAiIframeLoaded(true);
          });
      }
    }
  }, [isAiTab, isActive, aiIframeLoaded]);

  const clickHandler = () => {
    if (isActive) return;

    onClick({ id, unsupportedParams });
  };

  return (
    <div
      key={id}
      className={`relative transition-colors cursor-pointer mx-1 pl-1 md:pl-4 pr-2 md:pr-5 py-2 flex items-center justify-between border border-b-0 rounded-t-md ${isActive
        ? ' border-gray-300 bg-white text-blue-800'
        : 'border-transparent hover:text-blue-600 group'
        }`}
      onClick={clickHandler}
    >
      <Icon {...SearchTabIcons[title]} isActive={isActive} />
      <div>
        <span className={`${isActive ? 'font-semibold' : ''}`}>{title}</span>
        <span
          className={`block text-xs transition-colors ${isActive ? '' : 'text-gray-600 group-hover:text-blue-600'
            }`}
        >
          {subtitle}
        </span>
      </div>
      {isAiTab && !LP.config.ai_teacher_tools_only ? <span className="absolute bg-orange-600 text-white text-xs font-bold me-2 px-2.5 py-0.5 rounded-full top-0 right-[-30px]">new</span> : ''}
    </div>
  );
};

SearchTab.propTypes = {
  id: PropTypes.number,
  isActive: PropTypes.bool,
  onClick: PropTypes.func,
  title: PropTypes.string,
  subtitle: PropTypes.string,
  unsupportedParams: PropTypes.array
};

export default SearchTab;
